@use "../../styles/Colors.scss" as Colors;
@use "../../styles/Constants.scss" as Constants;

.project-sub-job-indicator {
	font-size: Constants.$val-fontSizeRegular;
	padding: Constants.$val-spacing-xxs Constants.$val-spacing-xs;
	text-transform: uppercase;
	font-weight: bold;
	border-radius: 1px;

	&.project {
		background-color: Colors.$col-darkBlueBorder;
		color: Colors.$col-white;
	}

	&.subjob {
		background-color: Colors.$col-design-blue200;
		color: Colors.$col-design-blue500;
	}
}
